import { useState } from 'react';
import { uid } from '@hkm/utils/uid';

export function useUid(): string {
  const [id] = useState(uid());

  return id;
}



// WEBPACK FOOTER //
// ./src/shared/hooks/useUid.ts